// src/components/image-dashboard/DeleteModal.jsx
import { useEffect, useRef } from "react";

const DeleteModal = ({ isOpen, filename, onCancel, onConfirm }) => {
    const modalRef = useRef(null);
    useEffect(() => {
        if (!isOpen) return;
        const handleEsc = e => { if (e.key === "Escape") onCancel(); };
        document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, [isOpen, onCancel]);

    if (!isOpen) return null;
    return (
        <div className="deleteModalOverlay" onClick={onCancel}>
            <div className="deleteModal upgraded" ref={modalRef} onClick={e => e.stopPropagation()}>
                <h3 className="modalTitle">Delete Image?</h3>
                <p className="modalMessage">Are you sure you want to delete <strong>{filename}</strong>?</p>
                <div className="modalButtons">
                    <button className="cancelBtn" onClick={onCancel}>Cancel</button>
                    <button className="deleteBtn" onClick={onConfirm}>Delete</button>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;
